import styled from 'styled-components';

export const Container = styled.div<{ form?: DOMRect; $justify?: 'flex-start' | 'center' | 'flex-end' }>`
  width: 100vw;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.$justify || 'space-between'};
  position: relative;
  overflow-x: hidden;
  //padding: 4.6rem 0;
  gap: 3.2rem;
  box-sizing: border-box;
`;

export const Form = styled.form`
  width: fit-content;
  min-width: 32rem;
  margin: 1.8rem auto;

  background-color: white;
  position: relative;
  z-index: 10;
  opacity: 0.95;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 3.2rem;

  @media only screen and (min-width: 500px) {
    min-width: 40rem;
  }

  #naverIdLogin_loginButton {
    img {
      border-radius: 50%;
      width: 5rem;
      height: 5rem;
    }
  }
`;

export const Divider = styled.div`
  flex: 1;
  width: 100%;
  border-top: 1px solid var(--light);
`;
